///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                           RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import UploadLanesModal from "./UploadLanesModal";
import { putBulkEdit } from "../../../api/lanes";
import { fetchBidSummary } from "../../../slices/bidSummarySlice";
import { fetchPricingLanes } from "../../../slices/bidPricingSlice";
import messages from "../../../helpers/messages";
import { userRole } from "../../../helpers/types";

export const BulkEditModal = ({ open, role, ...props }) => {
  const dispatch = useDispatch();
  const {
    featureFlags: { useStrategicQuantile },
    bidSummary: { summary }
  } = useSelector(state => state);

  const showStrategicQuantileBulkEditMessage =
    useStrategicQuantile &&
    (role === userRole.tlPricingAnalyst ||
      role === userRole.management ||
      role === userRole.assetBasedPricingUser);

  const handleSuccess = () => {
    const { bidId, handleClose } = props;

    dispatch(fetchBidSummary({ bidId, role }));
    dispatch(
      fetchPricingLanes({ bidId, role, isCoyoteBid: summary?.isCoyoteBid })
    );
    handleClose();
  };

  return (
    <>
      {open && (
        <UploadLanesModal
          modalMessage={
            !summary?.isCoyoteBid
              ? messages.bulkLaneEditModalBodyMessageV3.defaultMessage
              : showStrategicQuantileBulkEditMessage
              ? messages.bulkLaneEditModalBodyMessageV2.defaultMessage
              : messages.bulkLaneEditModalBodyMessage.defaultMessage
          }
          modalTitle={messages.bulkLaneEdit.defaultMessage}
          uploadApi={putBulkEdit}
          progressMessage={messages.bulkLaneEditProgressMessage.defaultMessage}
          showOnSuccessModal={false}
          onSuccess={handleSuccess}
          uploadButtonCaption={messages.import.defaultMessage}
          validationMessage={
            messages.bulkLaneEditValidationMessage.defaultMessage
          }
          role={role}
          {...props}
        />
      )}
    </>
  );
};

export default BulkEditModal;
